import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricCard = ({ 
  title, 
  value, 
  change, 
  changeType = 'positive',
  icon,
  trend = [],
  loading = false 
}) => {
  const changeColor = changeType === 'positive' ? 'text-success' : 
                      changeType === 'negative'? 'text-error' : 'text-muted-foreground';
  
  const changeIcon = changeType === 'positive' ? 'TrendingUp' : 
                     changeType === 'negative'? 'TrendingDown' : 'Minus';

  if (loading) {
    return (
      <div className="bg-card rounded-lg p-6 border border-border card-elevated-1">
        <div className="animate-pulse">
          <div className="h-4 bg-muted rounded w-1/2 mb-4"></div>
          <div className="h-8 bg-muted rounded w-3/4 mb-2"></div>
          <div className="h-3 bg-muted rounded w-1/3"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg p-6 border border-border card-elevated-1 hover:shadow-md transition-shadow duration-200">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <p className="text-sm text-muted-foreground mb-1">{title}</p>
          <h3 className="text-3xl font-semibold text-foreground">{value}</h3>
        </div>
        {icon && (
          <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center">
            <Icon name={icon} size={24} color="var(--color-primary)" />
          </div>
        )}
      </div>
      {change && (
        <div className="flex items-center gap-2">
          <Icon name={changeIcon} size={16} className={changeColor} />
          <span className={`text-sm font-medium ${changeColor}`}>
            {change}
          </span>
          <span className="text-xs text-muted-foreground">vs période précédente</span>
        </div>
      )}
      {trend?.length > 0 && (
        <div className="mt-4 flex items-end gap-1 h-8">
          {trend?.map((value, index) => (
            <div
              key={index}
              className="flex-1 bg-primary/20 rounded-t"
              style={{ height: `${value}%` }}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default MetricCard;